import {
        listResourceQueryDefinitions,
        viewResourceQueryDefinitions,
        createResourceMutationDefinitions,
        updateResourceMutationDefinitions,
        deleteResourceMutationDefinitions
} from '@/providers/graphql/resourceQueryDefinitions';
import gql from 'graphql-tag';

export const LIMIT_POLICIES_LIST_QUERY = gql`
        query LimitPolicies($where: LimitPolicyViewModelFilterInput, $first: Int, $after: String) {
                limitPolicies(where: $where, first: $first, after: $after) {
                        nodes {
                                limitPolicyId
                                name
                                priority
                                isActive
                                activatedAt
                                tariffId
                                scenario {
                                        scenarioId
                                        name
                                }
                                limit {
                                        limitId
                                        minAmount
                                        maxAmount
                                        minStayMinutes
                                        maxStayMinutes
                                }
                                billingCycle {
                                        billingCycleId
                                        name
                                }
                        }
                        pageInfo {
                                hasNextPage
                                endCursor
                        }
                }
        }
`;

export const LIMIT_POLICY_LIST_ITEM_QUERY = gql`
        query LimitPolicyListItem($id: Ulid!) {
                limitPolicy(limitPolicyId: $id) {
                        limitPolicyId
                        name
                        priority
                        isActive
                        activatedAt
                        tariffId
                        scenario {
                                scenarioId
                                name
                        }
                        limit {
                                limitId
                                minAmount
                                maxAmount
                                minStayMinutes
                                maxStayMinutes
                        }
                        billingCycle {
                                billingCycleId
                                name
                        }
                }
        }
`;

export const LIMIT_POLICY_QUERY = gql`
        query LimitPolicy($id: Ulid!) {
                limitPolicy(limitPolicyId: $id) {
                        limitPolicyId
                        name
                        priority
                        isActive
                        activatedAt
                        deactivatedAt
                        tariffId
                        scenario {
                                scenarioId
                                name
                        }
                        limit {
                                limitId
                                minAmount
                                maxAmount
                                minStayMinutes
                                maxStayMinutes
                        }
                        billingCycle {
                                billingCycleId
                                name
                        }
                }
        }
`;

export const LIMIT_POLICY_CREATE_MUTATION = gql`
        mutation CreateLimitPolicy($input: CreateLimitPolicyInput!) {
                createLimitPolicy(input: $input) {
                        success
                        errorCode
                        errorDescription
                        isErrored
                        failed
                }
        }
`;

export const LIMIT_POLICY_UPDATE_MUTATION = gql`
        mutation UpdateLimitPolicy($input: UpdateLimitPolicyInput!) {
                updateLimitPolicy(input: $input) {
                        success
                        errorCode
                        errorDescription
                        isErrored
                        failed
                }
        }
`;

export const LIMIT_POLICY_DELETE_MUTATION = gql`
        mutation DeleteLimitPolicy($input: DeleteLimitPolicyInput!) {
                deleteLimitPolicy(input: $input) {
                        success
                        errorCode
                        errorDescription
                        isErrored
                        failed
                }
        }
`;

listResourceQueryDefinitions['limitPolicies'] = {
        document: LIMIT_POLICIES_LIST_QUERY,
        dataPath: 'limitPolicies'
};

viewResourceQueryDefinitions['limitPolicies'] = {
        document: LIMIT_POLICY_QUERY,
        dataPath: 'limitPolicy'
};

createResourceMutationDefinitions['limitPolicies'] = {
        document: LIMIT_POLICY_CREATE_MUTATION,
        operation: 'createLimitPolicy',
        getVariables: variables => ({ input: variables })
};

updateResourceMutationDefinitions['limitPolicies'] = {
        document: LIMIT_POLICY_UPDATE_MUTATION,
        operation: 'updateLimitPolicy',
        getVariables: variables => ({ input: variables })
};

deleteResourceMutationDefinitions['limitPolicies'] = {
        document: LIMIT_POLICY_DELETE_MUTATION,
        operation: 'deleteLimitPolicy',
        getVariables: variables => ({ input: variables })
};
